module.exports = __webpack_public_path__ + "static/media/simulation.04ab8f41.mp4";